import type { FaireProductEntity } from "../../entity_types/product";

export const p_3jsmr4h2dx: FaireProductEntity = {
  token: "p_3jsmr4h2dx",
  type: "product",
  name: "CP-1217 Mahjong Game Bag",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl:
    "https://cdn.faire.com/fastly/c268e1df19a4387b7f403caa449ba124015072b4e5506d9e5f4b65d684c19d27.jpeg",
  galleryImageUrls: [],
  priceDollars: 9.5,
  description:
    "Our Candy Bags are a great everyday and travel accessory! They feature a wrist strap for hands free toting attached to a zipper for secure closure. These fun lettered bags are fun for carrying alone or stuffing into a larger tote or duffel! Check out each design!",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:48.062Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
